import { Suggestion } from '@g17eco/types/search';
import { ellipsis } from '@utils/index';
import { isOnboardingUser } from '@utils/user';

export const formatData = (suggestions: Suggestion[]) => {
  return suggestions.map((suggestion) => {
    const { status, firstName, surname } = suggestion;
    if (isOnboardingUser(status)) {
      suggestion.name = `${ellipsis(suggestion.email, 25)} (pending)`;
      return suggestion;
    }

    suggestion.name = `${firstName} ${surname}`;
    return suggestion;
  });
};
